import { Navigate } from 'react-router-dom';
import { usePermissions } from '../context/PermissionsContext';
import { NAVIGATION_TREE, type NavLeaf } from '../config/navigation';

/** Primera ruta del menú que el usuario puede ver (evita /forbidden en el home). */
export function firstAllowedHref(can: (module: string, action?: 'read' | 'write' | 'critical') => boolean): string {
  for (const entry of NAVIGATION_TREE) {
    if (entry.type === 'separator') continue;
    if (entry.type === 'link') {
      if (can(entry.module, entry.action ?? 'read')) return entry.href;
      continue;
    }
    for (const child of entry.children as NavLeaf[]) {
      if (can(child.module, child.action ?? 'read')) return child.href;
    }
  }
  return '/forbidden';
}

/** Home `/`: tablero si hay reports.read; si no, primer módulo permitido. */
export function HomeRedirect({ children }: { children: React.ReactNode }) {
  const { can, loading } = usePermissions();

  if (loading) {
    return <div className="p-6 text-gray-500 text-sm">Verificando permisos…</div>;
  }

  if (can('dashboard', 'read') || can('reports', 'read')) {
    return <>{children}</>;
  }

  const href = firstAllowedHref(can);
  if (href === '/forbidden') {
    return <Navigate to="/forbidden" replace />;
  }
  return <Navigate to={href} replace />;
}
